import { useState } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { COLOR, LAYOUT } from '../styles/theme';
import { SecondaryHeaderContext } from '../contexts/secondary-header';
import { AppHeaderLeadContext } from '../contexts/app-header-lead';
import { HeaderActionsContext } from '../contexts/header-actions';
import { OrdersTabExtraProvider } from '../contexts/orders-tab-extra';
import { WavesTabExtraProvider } from '../contexts/waves-tab-extra';
import { PackingTabExtraProvider } from '../contexts/packing-tab-extra';
import { TransferTabExtraProvider } from '../contexts/transfer-tab-extra';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';
import { SecondaryHeaderStrip } from './SecondaryHeaderStrip';

const { Content } = Layout;

const SimpleLayout = styled.div`
  background: ${COLOR.box};
  min-height: 100vh;
  height: 100%;
  overflow: auto;
`;

export function SecureAppLayout({ hideSidebar }) {
  const [secondaryHeader, setSecondaryHeader] = useState(null);
  const [headerLead, setHeaderLead] = useState(null);
  const [headerActions, setHeaderActions] = useState(null);

  if (hideSidebar) {
    return (
      <SimpleLayout>
        <Outlet />
      </SimpleLayout>
    );
  }

  return (
    <AppHeaderLeadContext.Provider
      value={{
        setLead: node => setHeaderLead(node),
        clearLead: () => setHeaderLead(null),
      }}
    >
      <HeaderActionsContext.Provider
        value={{
          setActions: node => setHeaderActions(node),
          clearActions: () => setHeaderActions(null),
        }}
      >
        <SecondaryHeaderContext.Provider
          value={{
            setHeader: node => setSecondaryHeader(node),
            clearHeader: () => setSecondaryHeader(null),
          }}
        >
          <OrdersTabExtraProvider>
            <WavesTabExtraProvider>
              <PackingTabExtraProvider>
                <TransferTabExtraProvider>
                  <Layout
                    style={{
                      height: '100vh',
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden',
                    }}
                  >
                    <Layout
                      hasSider
                      style={{
                        flex: 1,
                        minHeight: 0,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'stretch',
                      }}
                    >
                      <AppSidebar />
                      <Layout
                        style={{
                          flex: 1,
                          minHeight: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          overflow: 'hidden',
                        }}
                      >
                        <AppHeader
                          headerLead={headerLead}
                          headerActions={headerActions}
                        />
                        {secondaryHeader && (
                          <SecondaryHeaderStrip>{secondaryHeader}</SecondaryHeaderStrip>
                        )}
                        <Content
                          style={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            padding: LAYOUT.contentPadding,
                            background: COLOR.box,
                          }}
                        >
                          <Outlet />
                        </Content>
                      </Layout>
                    </Layout>
                  </Layout>
                </TransferTabExtraProvider>
              </PackingTabExtraProvider>
            </WavesTabExtraProvider>
          </OrdersTabExtraProvider>
        </SecondaryHeaderContext.Provider>
      </HeaderActionsContext.Provider>
    </AppHeaderLeadContext.Provider>
  );
}
